import 'store/types'
import { List, Map } from 'immutable'
import { getAuthIsLoggedIn } from 'services/auth'

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectName (state) {
  return state.user.getIn(['data', 'name'], '')
}

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectFirstName (state) {
  return state.user.getIn(['data', 'firstName'], '')
}

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectEmail (state) {
  return state.user.getIn(['data', 'mail'], '')
}

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectPrimaryLanguage (state) {
  const languages = state.user.getIn(['data', 'language'], undefined)
  return List.isList(languages) ? languages.first() : undefined
}

/**
 * @param {ReduxState} state redux state
 * @returns {Bool}
 */
export function selectEmailAvailabilityProcessing (state) {
  return state.user.get('emailAvailabilityProcessing', undefined)
}

/**
 * @param {ReduxState} state redux state
 * @returns {Bool}
 */
export function selectEmailAvailability (state) {
  return state.user.get('emailAvailable', null)
}

/**
 * @param {ReduxState} state redux state
 * @returns {Bool}
 */
export function selectHasEmailAvailable (state) {
  return state.user.has('emailAvailable')
}

/**
 * @param {ReduxState} state redux state
 * @returns {Bool}
 */
export function selectHasChildProfile (state) {
  return state.user.has('childProfile')
}

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectUserExternalId (state) {
  const { auth = Map(), user = Map() } = state
  const isLoggedIn = getAuthIsLoggedIn(auth)
  const externalId = !isLoggedIn ? user.getIn(['data', 'anonymousUuid'], '') : user.getIn(['data', 'uuid'], '') || user.getIn(['data', 'anonymousUuid'], '')

  return externalId
}
